import axios from 'axios';

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  // 60s: operações que falam com serviços externos (Gmail IMAP/SMTP, SEFIN/NFS-e
  // por mTLS) podem demorar mais que os 15s antigos e abortavam no meio.
  timeout: 60000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('automator_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('automator_token');
      localStorage.removeItem('automator_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  },
);

/** Extrai mensagem de erro legível de qualquer erro de request (axios/JSON/string). */
export function apiErrorMessage(err: any, fallback = 'Algo deu errado'): string {
  const data = err?.response?.data;
  if (data && typeof data === 'object' && data.message) return data.message;
  if (typeof data === 'string' && data.trim()) return data;
  if (err?.message) return err.message;
  return fallback;
}

/** Extrai mensagem de erro de uma resposta blob (preview PDF que falhou retorna JSON). */
export async function blobErrorMessage(err: any, fallback = 'Erro'): Promise<string> {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      return JSON.parse(await data.text()).message || fallback;
    } catch {
      return fallback;
    }
  }
  return data?.message || err?.message || fallback;
}
